
import React, { useState } from "react";
import UserContextProvider, { ContextModel, User, EventData, OrderData, Config } from "../interface/interfaces";

interface Props {
    children: React.ReactNode;
}

const Context: React.FC<Props> = (props) => {
    const [user, setUser] = useState<User>({
        id: 0,
        name: "",
        lastname: "",
        email: "",
        cards: [],
        dui: "",
        phone: "",
        photo: ""
    });

    const [event, setEvent] = useState<EventData>({});

    const [order, setOrder] = useState<OrderData>({});

    //Codigo de pais para obtener los eventos por pais
    const [config, setConfig] = useState<Config>({
        countryCode: "SV",
        storeKey: "SJ5b3V85JVtYZIfd8dvx_vacio"
    });

    const [events, setEvents] = useState<EventData[]>([]);

    const asignateEventData = (eventData: EventData) => {
        setEvent(eventData);
    };

    const asignateUser = (userData: User) => {
        setUser(userData);
    };

    const asignateOrderData = (orderData: OrderData) => {
        setOrder(orderData);
    };

    const asignateConfig = (configData: Config) => {
        setConfig(configData);
    }

    const asignateEventsArray = (eventsData: EventData[]) => {
        setEvents(eventsData);
    }

    const contextValue: ContextModel = {
        user,
        event,
        order,
        config,
        events,
        asignateEventsArray,
        asignateOrderData,
        asignateEventData,
        asignateUser,
        asignateConfig,
    };

    return (
        <UserContextProvider.Provider value={contextValue}>
            {props.children}
        </UserContextProvider.Provider>
    )
};

export default Context;